import firebaseApp from '../configuration/firebase-setup';
import moment from 'moment'

const database = firebaseApp.database();
class firebaseRtDbServices {

  onSlotSuccess = (accId, slotID, phoneNumber, callbackFncSucc, callbackFncAlready, timeoutFnc) => {
    const appointmentStatusRef = database.ref(`${accId}/entityUpdateNotifications/SlotBookStatus/extraDict/${phoneNumber}/${slotID}`);
    let status = false      
      setTimeout(() => {
        if (status === false) {
          timeoutFnc();
          appointmentStatusRef.off()
        }
      }, 60000);
    appointmentStatusRef.on('value', (snapshot) => {  
      console.log(snapshot.val())  
      if (snapshot.val() !== null) {        
        if (snapshot.val() === 'already-booked') {
          callbackFncAlready();
          status = true
        }
        else if (snapshot.val() === 'success') {
          callbackFncSucc();
          status = true
        }
        appointmentStatusRef.off()
      }
    })
  }
}
const FirebaseDBObj = new firebaseRtDbServices();
export default FirebaseDBObj;
